module.exports = __webpack_public_path__ + "static/Post_1-0fe7fe84c56998145517be17032fab02.png";